import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
const qs = require("qs");

// axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
  baseURL: process.env.VUE_APP_AIRDROP_API,
  timeout: 120000
});
service.interceptors.request.use(
  config => {
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // if (getToken()) {
    //   config.headers["Authorization"] = "Bearer " + getToken();
    // }

    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    const code = res.data.code;
    // console.log("res222",res);
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res;
    }

    if (code == "-5" || res.data.error == "please login") {
      MessageBox.confirm(
        "The login status has expired. You can stay on this page or log in again",
        "System prompt",
        {
          confirmButtonText: "Login again",
          cancelButtonText: "cancel",
          type: "warning"
        }
      ).then(() => {
        store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    } else if (+code !== 0) {
      console.log('res.data.error', res);
      Notification.error({
        title: res.data.error
      });
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  error => {
    console.log('Error details:', {
      message: error.message,
      response: error.response
    });
    if(error.message != "cancel"){
      Message({
        message:error.response?error.response.data.error:error,
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(error);
    }
  }
);

export default service;
